import React from 'react';
interface PaintStrokeProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}
export function PaintStroke({
  color = 'currentColor',
  className,
  ...props
}: PaintStrokeProps) {
  return <svg viewBox="0 0 200 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} preserveAspectRatio="none" {...props} data-id="element-161">
      <path d="M2 10C35.5 4.5 70.5 14.5 105 12C139.5 9.5 170.5 15.5 198 8" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" className="opacity-80" data-id="element-162" />
      <path d="M15 14C45 18 80 8 115 11C150 14 175 16 190 12" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="opacity-40" data-id="element-163" />
    </svg>;
}